import { useEffect } from 'react';

/**
 * Client-side title/description for in-app navigation. The prerender pass
 * (scripts/prerender.mjs) bakes the same values into the static HTML for
 * crawlers, so this only matters once the SPA is running.
 */
export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector<HTMLMetaElement>("meta[name='description']");
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'description');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', description);
  }, [title, description]);
}
